import { render, staticRenderFns } from "./mortgage-cash-purchase.vue?vue&type=template&id=1133598f"
import script from "./mortgage-cash-purchase.vue?vue&type=script&lang=js"
export * from "./mortgage-cash-purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports